export default "__VITE_ASSET__BC99$0zT__"